export default __webpack_public_path__ + "static/media/Live-Gists-preview.0fa061b4.png";